// One camera for two 3D scans: whichever pane the viewer touches leads, and
// the other pane copies its camera and orbit target on every change. Pure
// enough to test with fakes (anything with camera/controls like three.js).

function copyView(from, to) {
  to.camera.position.copy(from.camera.position);
  to.camera.quaternion.copy(from.camera.quaternion);
  to.camera.near = from.camera.near;
  to.camera.far = from.camera.far;
  if (typeof to.camera.updateProjectionMatrix === 'function') to.camera.updateProjectionMatrix();
  to.controls.target.copy(from.controls.target);
  to.controls.minDistance = from.controls.minDistance;
  to.controls.maxDistance = from.controls.maxDistance;
  // One undamped update flushes any glide left over from the follower's own
  // last drag (damping never quite reaches zero), then pin it exactly again.
  const damping = to.controls.enableDamping;
  to.controls.enableDamping = false;
  to.controls.update();
  to.controls.enableDamping = damping;
  to.camera.position.copy(from.camera.position);
  to.camera.quaternion.copy(from.camera.quaternion);
  to.controls.target.copy(from.controls.target);
}

export function linkCameras(views) {
  const list = (views || []).filter((v) => v && v.camera && v.controls);
  if (list.length < 2) return { sync: () => {}, lead: () => {}, unlink: () => {} };
  let leader = 0;
  let syncing = false;
  const sync = (from = leader) => {
    if (syncing) return;
    syncing = true;
    try {
      list.forEach((v, j) => { if (j !== from) copyView(list[from], v); });
    } finally {
      syncing = false;
    }
  };
  const offs = [];
  list.forEach((v, i) => {
    const take = () => { leader = i; };
    const onChange = () => { if (i === leader) sync(i); };
    v.controls.addEventListener('start', take);
    v.controls.addEventListener('change', onChange);
    offs.push(() => {
      v.controls.removeEventListener('start', take);
      v.controls.removeEventListener('change', onChange);
    });
    const el = v.controls.domElement;
    if (el && typeof el.addEventListener === 'function') {
      ['pointerdown', 'wheel', 'focus', 'keydown'].forEach((ev) => {
        el.addEventListener(ev, take, { passive: true });
        offs.push(() => el.removeEventListener(ev, take));
      });
    }
  });
  return {
    sync,
    lead: (i) => { if (i >= 0 && i < list.length) leader = i; },
    unlink: () => offs.splice(0).forEach((off) => off()),
  };
}
